export function SolutionSection() {
    return (
        <section className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">
                        Our AI Humanization Solution
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Advanced algorithms that restructure, rephrase, and optimize your AI content to sound
                        natural and human-like while maintaining the original meaning and intent.
                    </p>
                </div>
            </div>
        </section>
    );
}